import angular from "angular";
import htmlTemplate from "./fill_checklist_panel.html";

export default angular
    .module("sbApp.sbFillChecklistPanel", [])
    .directive("sbFillChecklistPanel", function () {
        return {
            restrict: "E",
            replace: true,
            bindToController: true,
            controllerAs: "$ctrl",
            templateUrl: htmlTemplate,
            scope: {
                deliverableId: "<",
                deliverableName: "<",
                structureId: "<",
                activityId: "<",
                activityName: "<",
                projectId: "<",
                isOpen: "=",
                fromState: "<",
                activityState: "<",
                approvalType: "<",
                toState: "<",
            },
            controller: function FillChecklistCtrl(
                $sbStructure,
                $sbCurrentProject
            ) {
                "ngInject";
                const vm = this;
                vm.activate = activate;

                function activate() {
                    if (vm.isOpen) {
                        const el = document.getElementById("angular-checklist");

                        el.toState = vm.toState.toLowerCase();
                        el.deliverableId = vm.deliverableId;
                        el.deliverableName = vm.deliverableName || "";
                        el.activityId = vm.activityId;
                        el.activityName = vm.activityName;
                        el.activityState = vm.activityState.toLowerCase();
                        el.approvalType = vm.approvalType;

                        const projectId =
                            vm.projectId || $sbCurrentProject.pick("id");

                        if (projectId && vm.structureId) {
                            $sbStructure
                                .node(projectId, vm.structureId)
                                .then(
                                    (node) =>
                                        (el.location =
                                            node?.PARENT_PATH.join(" / ")) || ""
                                )
                                .catch(function onLocationLoadError() {
                                    el.location = "";
                                });
                        } else {
                            el.location = "";
                        }
                    }
                }
            },
            link: function (scope, element, attrs, controller) {
                scope.$watch("$ctrl.isOpen", function () {
                    controller.activate();
                });
            },
        };
    });
